module.exports = __webpack_public_path__ + "c040f79f849279bafdf9cc60babd8f5e.svg";